// write class function to render the home screen
import React, { Component } from 'react';
import { StyleSheet, Text, View, TouchableOpacity, TextInput, Alert, ScrollView, Button } from 'react-native';
import init from 'react_native_mqtt';
import AsyncStorage from '@react-native-async-storage/async-storage';
import config from '../../config';
import { getArtists, postArtistAnswer, getPoints } from '../services/artist.service';
import { getReleases, postReleaseAnswer } from '../services/release.service';
import { Autocomplete, Card, CardContent, CardHeader, FormHelperText, LinearProgress, linearProgressClasses, styled, TextField } from '@mui/material';
import axios from 'axios';
import i18n from './../../util/i18n';
import { getMovies, postMovieAnswer } from '../services/movie.service';
// import { getSongDetailsFunction } from '../services/song.service';
// import CircularProgress from '@mui/material/CircularProgress';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DangerousIcon from '@mui/icons-material/Dangerous';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import logo from './../../assets/logo.png';
import { getLanguages, postLanguageAnswer } from '../services/language.service';
import { LinearGradient } from 'expo-linear-gradient';


i18n.locale = 'fr';

init({
    size: 10000,
    storageBackend: AsyncStorage,
    defaultExpires: 1000 * 3600 * 24,
    enableCache: true,
    reconnect: true,
    sync: {
    }
});


const StyledLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: 'transparent',
      ...theme.applyStyles('dark', {
        backgroundColor: theme.palette.grey[800],
      }),
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: config.colors.logo_blue,
      ...theme.applyStyles('dark', {
        backgroundColor: config.colors.logo_blue,
      }),
    },
}));

const StyledAutocomplete = styled(Autocomplete)(({ theme }) => ({
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: config.colors.logo_blue,
        },
        '&:hover fieldset': {
            borderColor: config.colors.logo_blue,
        },
        '&.Mui-focused fieldset': {
            borderColor: config.colors.logo_blue,
        },
    },
}));


export default class Home extends Component {

    constructor(props) {
        super(props);
        this.state = {
            releases: [],
            artists: [],
            movies: [],
            languages: [],
            release: '',
            artist: '',
            movie: '',
            language: '',
            releaseCheckmark: false,
            artistCheckmark: false,
            movieCheckmark: false,
            languageCheckmark: false,
            releaseId: '',
            artistId: '',
            movieId: '',
            languageId: '',
            loading: true,
            mqttStatus: 'connecting',
            songId: '',
            categoryId: '',
            timeout: '',
            countdown: '',
            countDownPercentage: '',
            disabled: false,
            timeoutId: null,
            timeoutTimeInSeconds: null,
            groupId: this.props?.route?.params?.group_id?.trim() || '',
            groupTotalPoints: 0,
            groupRank: 0,
            groupLeaderboard: [],
            groupCategoryTotalPoints: 0,
            groupCategoryRank: 0,
            groupCategoryLeaderboard: [],
            totalPoints: 0,
            artistPoints: null,
            releasePoints: null,
            moviePoints: null,
            languagePoints: null,
            hasRelease: false,
            hasArtist: false,
            hasMovie: false,
            hasLanguage: false,
        };

        this.client = null;

        // Connect to MQTT broker here
        let clientId = Math.random().toString(36).substring(7);
        // this.client = new Paho.MQTT.Client(config.mqtt.host, clientId);
        let url = `${config.mqtt.host}`;
        this.client = new Paho.MQTT.Client(url, clientId);
        this.client.onConnectionLost = this.onConnectionLost;
        this.client.onMessageArrived = this.onMessageArrived;
        this.client.connect({
            useSSL: false,
            // userName:config.mqtt.user,
            // password:config.mqtt.pass,
            onSuccess: this.onConnect,
            onFailure: this.onFailure
        });
        this.movieRef = React.createRef();
        this.releaseRef = React.createRef();
        this.artistRef = React.createRef();
        this.languageRef = React.createRef();
    }


    // set state async
    setStateAsync(state) {
        return new Promise((resolve) => {
            this.setState(state, resolve)
        });
    }

    // store group id in local storage
    storeGroupId = async () => {
        try {
            const group_id = this.props?.route?.params?.group_id?.trim() || '';
            await AsyncStorage.setItem('group_id', group_id)
            return group_id;
        } catch (e) {
            console.log("Error in storeGroupId", e.message);
            return null;
        }
    }

    async componentDidMount() {
        document.documentElement.lang = 'fr';
        const group_id = await this.storeGroupId();

        if (!group_id) {
            await AsyncStorage.removeItem('group_id');
            this.props.navigation.navigate('Login');
            return;
        }
        
        // We will make API call to get releases, artists, movies and languages here just to test whether the API server is working fine or not
        this.populateReleases();
        this.populateArtists();
        this.populateMovies();
        this.populateLanguages();
        
        this.getGroupPoints();
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    showCountdown = (timeoutTime) => {
        let remainingTime = timeoutTime - new Date().getTime();
        this.setState({
            countdown: parseInt(remainingTime / 1000),
            countDownPercentage: (parseInt(remainingTime / 1000) / this.state.timeoutTimeInSeconds * 100)
        });
        if (remainingTime >= 0) {
            setTimeout(() => {
                if (this.state.countdown === '') {
                    if (this.state.songId)
                        this.getPoints(this.state.songId);
                    this.setState({ countdown: '', countDownPercentage: '', songId: '', release: '', artist: '', movie: '', language: '' });
                    return;
                }
                this.showCountdown(timeoutTime);
            }, 100);
        } else {
            if (this.state.songId)
                this.getPoints(this.state.songId);
            this.setState({ countdown: '', countDownPercentage: '', songId: '', release: '', artist: '', movie: '', language: '' });
        }
    }

    sendMqttMessage = (topic, message) => {
        message = JSON.stringify(message);
        this.setState({ buttonText: 'Sending...' });
        var message = new Paho.MQTT.Message(message);
        message.destinationName = topic;
        this.client.send(message);
    }

    populateReleases = async (search = '') => {
        let response = await getReleases({ search: search });
        if (response?.error) {
            alert('Error', response.error);
            return;
        }
        let releases = response?.releases ? response.releases : [];
        releases = releases.map(release => {
            return {
                id: release._id,
                label: release.title,
                value: release._id
            }
        })
        this.setState({ releases: releases });
    }

    sendReleaseAnswer = async (release_id, remainingTime, totalTimeOfSong) => {
        let answeredTime = totalTimeOfSong - remainingTime;
        let user_id = this.props?.route?.params?.group_id?.trim() || '';
        let song_id = this.state.songId;
        let category_id = this.state.categoryId;
        let data = {
            user_id: user_id,
            category_id: category_id,
            song_id: song_id,
            release_id: release_id,
            answeredTime: answeredTime,
            totalTimeOfSong: totalTimeOfSong
        }

        let response = await postReleaseAnswer(data);
        this.setState({ releasePoints: response.releaseAnswer.points });
        this.getGroupPoints();
    }


    populateArtists = async (search = '') => {
        let response = await getArtists({ search: search });
        if (response?.error) {
            alert('Error', response.error);
            return;
        }
        let artists = response?.artists ? response.artists : [];
        artists = artists.map(artist => {
            return {
                id: artist._id,
                label: artist.name,
                value: artist._id
            }
        })
        this.setState({ artists: artists });
    }

    sendArtistAnswer = async (artist_id, remainingTime, totalTimeOfSong) => {
        let answeredTime = totalTimeOfSong - remainingTime;
        let group_id = this.props?.route?.params?.group_id?.trim() || '';
        let song_id = this.state.songId;
        let category_id = this.state.categoryId;
        let data = {
            user_id: group_id,
            category_id: category_id,
            song_id: song_id,
            artist_id: artist_id,
            answeredTime: answeredTime,
            totalTimeOfSong: totalTimeOfSong
        }

        let response = await postArtistAnswer(data);
        this.setState({ artistPoints: response.artistAnswer.points });
        this.getGroupPoints();
    }


    populateMovies = async (search = '') => {
        let response = await getMovies({ search: search });
        if (response?.error) {
            alert('Error', response.error);
            return;
        }
        let movies = response?.movies ? response.movies : [];

        movies = movies.map(movie => {
            return {
                id: movie._id,
                label: movie.name,
                value: movie._id
            }
        })
        this.setState({ movies: movies });
    }


    sendMovieAnswer = async (movie_id, remainingTime, totalTimeOfSong) => {
        let answeredTime = totalTimeOfSong - remainingTime;
        let group_id = this.props?.route?.params?.group_id?.trim() || '';
        let song_id = this.state.songId;
        let category_id = this.state.categoryId;
        let data = {
            user_id: group_id,
            category_id: category_id,
            song_id: song_id,
            movie_id: movie_id,
            answeredTime: answeredTime,
            totalTimeOfSong: totalTimeOfSong
        }

        let response = await postMovieAnswer(data);
        this.setState({ moviePoints: response.movieAnswer.points });
        this.getGroupPoints();
    }


    populateLanguages = async (search = '') => {
        let response = await getLanguages({ search: search });
        if (response?.error) {
            alert('Error', response.error);
            return;
        }
        let languages = response?.languages ? response.languages : [];
        languages = languages.map(language => {
            return {
                id: language._id,
                label: language.name,
                value: language._id
            }
        })
        this.setState({ languages: languages });
    }

    sendLanguageAnswer = async (language_id, remainingTime, totalTimeOfSong) => {
        let answeredTime = totalTimeOfSong - remainingTime;
        let group_id = this.props?.route?.params?.group_id?.trim() || '';
        let song_id = this.state.songId;
        let category_id = this.state.categoryId;
        let data = {
            user_id: group_id,
            category_id: category_id,
            song_id: song_id,
            language_id: language_id,
            answeredTime: answeredTime,
            totalTimeOfSong: totalTimeOfSong
        }

        let response = await postLanguageAnswer(data);
        this.setState({ languagePoints: response.languageAnswer.points });
        this.getGroupPoints();
    }


    // getSongDetails = async (song_id) => {
    //     let response = await getSongDetailsFunction(song_id);
    //     await this.setStateAsync({ hasArtist: response?.song?.has_artist, hasRelease: response?.song?.has_release, hasMovie: response?.song?.has_movie, hasLanguage: response?.song?.has_language });
    //     // if has movie is true focus to movie field else focus to release field

    //     if (response?.song?.has_movie) {
    //         this.movieRef.current.focus();
    //     } else if (response?.song?.has_release) {
    //         this.releaseRef.current.focus();
    //     } else {
    //         this.artistRef.current.focus();
    //     }
    // }

    focusInputProperly = async (payload) => {
        if (payload.hasMovie) {
            this.movieRef.current.focus();
        } else if (payload.hasRelease) {
            this.releaseRef.current.focus();
        } else if (payload.hasArtist) {
            this.artistRef.current.focus();
        } else if (payload.hasLanguage) {
            this.languageRef.current.focus();
        }
    }


    getGroupPoints = async () => {
        let baseUrl = config.base_url;
        let group_id = this.props?.route?.params?.group_id?.trim() || '';
        let response = await axios.get(baseUrl + '/points/' + group_id);
        this.setState({ groupTotalPoints: response?.data?.totalPoints || 0, groupRank: response?.data?.rank || '-', groupLeaderboard: response?.data?.leaderboard || [] });
        if (this.state?.categoryId) {
            let categoryResponse = await axios.get(baseUrl + '/points/groups/' + group_id + '/categories/' + this.state.categoryId);
            this.setState({ groupCategoryTotalPoints: categoryResponse?.data?.totalPoints || 0, groupCategoryRank: categoryResponse?.data?.rank || 0, groupCategoryLeaderboard: categoryResponse?.data?.leaderboard || [] });
        }
    }

    getPoints = async (song_id = null) => {
        let group_id = this.props?.route?.params?.group_id?.trim() || '';
        // await getBonusPoints({ song_id: song_id });
        let response = await getPoints({ group_id: group_id, song_id: song_id });
        this.setState({ totalPoints: response?.points });
    }

    onConnect = () => {
        console.log("Connected to MQTT Broker!");
        this.client.subscribe(config.mqtt.topic);
        this.setState({ mqttStatus: 'connected' });
    }

    onFailure = (responseObject) => {
        this.setState({ mqttStatus: 'failed' });
        console.log("Connection to MQTT Broker Failed: ", responseObject.errorMessage);
        // Try to reconnect after 5 seconds
        setTimeout(() => {
            try {
                this.client.connect({
                    useSSL: false,
                    // userName:config.mqtt.user,
                    // password:config.mqtt.pass,
                    onSuccess: this.onConnect,
                    onFailure: this.onFailure
                });
            } catch (e) {
                console.log("Reconnection attempt failed: ", e.message);
            }
        }, 5000);
    }

    onConnectionLost = (responseObject) => {
        if (responseObject.errorCode !== 0) {
            this.setState({ mqttStatus: 'lost' });
            console.log("Connection Lost: ", responseObject.errorMessage);
        }
    }

    onMessageArrived = async (message) => {
        // let songId = message.topic.split('/')[2];
        let payloadString = JSON.parse(message.payloadString)
        let songId = payloadString.songId;
        let categoryId = payloadString.categoryId;
        let timeoutTime = payloadString.timeoutTime;

        const mode = payloadString.mode;
        if (mode === 'stop') {
            this.setState({ countdown: '' });
            return;
        }


        await this.setStateAsync({
            songId: songId,
            categoryId: categoryId,
            hasArtist: payloadString.hasArtist,
            hasRelease: payloadString.hasRelease,
            hasMovie: payloadString.hasMovie,
            hasLanguage: payloadString.hasLanguage,
        });
        this.focusInputProperly(payloadString);
        // this.getSongDetails(songId);
        this.showCountdown(timeoutTime);
        this.getGroupPoints();
        this.setState({ timeoutTimeInSeconds: payloadString.timeoutTimeInSeconds });
        this.setState({ totalPoints: 0 });
        this.setState({ releases: [], artists: [], movies: [], languages: [] });
        this.setState({ releasePoints: null, artistPoints: null, moviePoints: null, languagePoints: null });
        this.setState({ releaseCheckmark: false, artistCheckmark: false, movieCheckmark: false, languageCheckmark: false });
    }

    render() {
        let group_id = this.props?.route?.params?.group_id?.trim() || '';

        if (!group_id) {
            return (
                <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
                    <Text style={{ fontSize: 16, margin: 10, fontWeight: '600' }}>{i18n.t('no_group_id')}</Text>
                    <Button title={i18n.t('set_my_group_id_now')}
                        onPress={async () => {
                            await AsyncStorage.removeItem('group_id');
                            this.props.navigation.navigate('Login')
                        }}
                    />
                </View>
            );
            
        }

        AsyncStorage.setItem('group_id', group_id);

        return (
            <View style={{ flex: 1 }}>

                <View style={{ textAlign: 'center', alignItems: 'center', justifyContent: 'center', borderBottomWidth: 1, borderBottomColor: 'lightgray' }}>
                    <Text style={{ fontSize: 16, margin: 10, fontWeight: '600' }}>{group_id}</Text>
                    <View style={{ position: 'absolute', right: 20 }}>
                        <TouchableOpacity onPress={async () => {
                            await AsyncStorage.removeItem('group_id');
                            this.props.navigation.navigate('Login');
                        }}>
                            <Text style={{ fontSize: 14, color: config.colors.logo_pink }}>{i18n.t('logout')}</Text>
                        </TouchableOpacity>
                    </View>
                </View>
                

                {(this.state.songId) ? null : (
                    <LinearGradient
                        style={{ flexGrow: 1 }}
                        colors={['rgba(236,193,161,1)', 'rgba(213,182,216,1)']}
                    >
                    <ScrollView
                        contentContainerStyle={{ flexGrow: 1, alignItems: 'center', justifyContent: 'space-around' }}
                    >
                    
                        <img
                            src={logo}
                            width={150}
                            height={'auto'}
                        />


                        <View style={{ alignItems: 'center' }}>
                            <Text style={{ fontSize: 20, fontWeight: 'bold', margin: 10, textAlign: 'center', color: config.colors.font_color }}>{i18n.t('waiting_for_next_music')}</Text>
                        </View>


                        {(this.state.groupRank || this.state.groupCategoryRank) ? (
                            <Card style={{ width: '90%', backgroundColor: config.colors.ranking_background }}>
                                <CardContent>
                                    <View style={{ flexDirection: 'column', justifyContent: 'space-between' }}>
                                        <Text style={{ fontSize: 16, flex: 1, textAlign: 'center', color: config.colors.font_color }}>
                                            {i18n.t('global_rank')}  -  <Text style={{ fontWeight: 'bold', color: config.colors.font_color }}>{`#${this.state.groupRank || '-'}`}</Text> ({this.state.groupTotalPoints} pts)
                                        </Text>
                                        <br />
                                        <Text style={{ fontSize: 16, flex: 1, textAlign: 'center', color: config.colors.font_color }}>
                                            {i18n.t('category_rank')}  -  <Text style={{ fontWeight: 'bold', color: config.colors.font_color }}>#{this.state.groupCategoryRank || '-'}</Text> ({this.state.groupCategoryTotalPoints} pts)
                                        </Text>
                                    </View>
                                </CardContent>
                            </Card>
                        ) : null}


                        <View style={{ width: '100%', justifyContent: 'space-around', alignItems: 'center', flexDirection: 'row' }}>
                            
                            {(this.state.hasMovie) ? (
                                <View style={{ alignItems: 'center' }}>
                                    <Text style={{ fontSize: 14, margin: 10, color: config.colors.font_color }}>{i18n.t('movie')}</Text>
                                    {(this.state.moviePoints > 0) ? (
                                        <>
                                            <CheckCircleIcon style={{ color: 'green', fontSize: 40, margin: 10 }} />
                                            <Text style={{ fontSize: 14, margin: 10, color: config.colors.font_color }}>{`${this.state.moviePoints} pt`}</Text>
                                        </>
                                    ) : (
                                        <>
                                            <DangerousIcon style={{ color: 'red', fontSize: 40, margin: 10 }} />
                                            <Text style={{ fontSize: 14, margin: 10, color: config.colors.font_color }}>{`${this?.state?.moviePoints || 0} pt`}</Text>
                                        </>
                                    )}
                                </View>
                            ) : null}

                            {(this.state.hasRelease) ? (
                                <View style={{ alignItems: 'center' }}>
                                    <Text style={{ fontSize: 14, margin: 10, color: config.colors.font_color }}>{i18n.t('title')}</Text>
                                    {(this.state.releasePoints > 0) ? (
                                        <>
                                            <CheckCircleIcon style={{ color: 'green', fontSize: 40, margin: 10 }} />
                                            <Text style={{ fontSize: 14, margin: 10, color: config.colors.font_color }}>{`${this.state.releasePoints} pt`}</Text>
                                        </>
                                    ) : (
                                        <>
                                            <DangerousIcon style={{ color: 'red', fontSize: 40, margin: 10 }} />
                                            <Text style={{ fontSize: 14, margin: 10, color: config.colors.font_color }}>{`${this?.state?.releasePoints || 0} pt`}</Text>
                                        </>
                                    )}
                                </View>
                            ) : null}
                            
                            {(this.state.hasArtist) ? (
                                <View style={{ alignItems: 'center' }}>
                                    <Text style={{ fontSize: 14, margin: 10, color: config.colors.font_color }}>{i18n.t('artist')}</Text>
                                    {(this.state.artistPoints > 0) ? (
                                        <>
                                            <CheckCircleIcon style={{ color: 'green', fontSize: 40, margin: 10 }} />
                                            <Text style={{ fontSize: 14, margin: 10, color: config.colors.font_color }}>{`${this.state.artistPoints} pt`}</Text>
                                        </>
                                    ) : (
                                        <>
                                            <DangerousIcon style={{ color: 'red', fontSize: 40, margin: 10 }} />
                                            <Text style={{ fontSize: 14, margin: 10, color: config.colors.font_color }}>{`${this?.state?.artistPoints || 0} pt`}</Text>
                                        </>
                                    )}
                                </View>
                            ) : null}
                            
                            {(this.state.hasLanguage) ? (
                                <View style={{ alignItems: 'center' }}>
                                    <Text style={{ fontSize: 14, margin: 10, color: config.colors.font_color }}>{i18n.t('language')}</Text>
                                    {(this.state.languagePoints > 0) ? (
                                        <>
                                            <CheckCircleIcon style={{ color: 'green', fontSize: 40, margin: 10 }} />
                                            <Text style={{ fontSize: 14, margin: 10, color: config.colors.font_color }}>{`${this.state.languagePoints} pt`}</Text>
                                        </>
                                    ) : (
                                        <>
                                            <DangerousIcon style={{ color: 'red', fontSize: 40, margin: 10 }} />
                                            <Text style={{ fontSize: 14, margin: 10, color: config.colors.font_color }}>{`${this?.state?.languagePoints || 0} pt`}</Text>
                                        </>
                                    )}
                                </View>
                            ) : null}
                        </View>

                        {/* Score and points */}
                        <View style={{width: '90%'}}>
                            <View style={{justifyContent: 'space-between', flexDirection: 'row'}}>
                                <Text style={{ fontSize: 20, marginVertical: 10, color: config.colors.font_color }}>{i18n.t('points_obtained')}</Text>
                                <Text style={{ fontSize: 20, marginVertical: 10, color: config.colors.font_color }}>{this.state.totalPoints}</Text>
                            </View>
                            {/* <View style={{justifyContent: 'space-between', flexDirection: 'row'}}>
                                <Text style={{ fontSize: 22, fontWeight: 'bold', marginVertical: 10, marginHorizontal: 20 }}>{i18n.t('total_points')}</Text>
                                <Text style={{ fontSize: 22, fontWeight: 'bold', marginVertical: 10, marginHorizontal: 20 }}>{this.state.groupTotalPoints}</Text>
                            </View> */}
                        </View>

                        {/* Group Leaderboard */}
                        {(this.state.groupLeaderboard && this.state.groupLeaderboard.length > 0) ? (
                            <Card style={{ width: '90%', marginVertical: 20, padding: 10, backgroundColor: config.colors.ranking_background }}>
                                <CardHeader title={i18n.t('leaderboard')} style={{ textAlign: 'center', backgroundColor: config.colors.ranking_highlight, padding: 5, color: config.colors.font_color }} />
                                <CardContent>
                                    {this.state.groupLeaderboard.map((member, index) => (
                                        <View key={index} style={{ flexDirection: 'row', marginVertical: 5 }}>
                                            <Text style={{ fontSize: member.current_user ? 16 : 16, fontWeight: member.current_user ? 'bold' : 'normal', flex: 1, color: config.colors.font_color }}>#{member.rank}</Text>
                                            <Text style={{ fontSize: member.current_user ? 16 : 16, fontWeight: member.current_user ? 'bold' : 'normal', flex: 1, textAlign: 'center', color: config.colors.font_color }}>{member.user_id}</Text>
                                            <Text style={{ fontSize: member.current_user ? 16 : 16, fontWeight: member.current_user ? 'bold' : 'normal', flex: 1, textAlign: 'right', color: config.colors.font_color }}>{member.points} pts</Text>
                                        </View>
                                    ))}
                                </CardContent>
                            </Card>
                        ) : null}

                    </ScrollView>
                    </LinearGradient>
                    
                )}
                


                {this.state.countdown > 0 ? (
                    <LinearGradient
                        style={{ flexGrow: 1 }}
                        colors={['rgba(236,193,161,1)', 'rgba(213,182,216,1)']}
                    >
                    <ScrollView
                        contentContainerStyle={{ flexGrow: 1, alignItems: 'center' }}
                    >

                        <View style={{width: '90%' }}>
                            <View style={{ width: '100%', alignItems: 'center', marginBottom: 10 }}>
                                <Text style={{ fontSize: 70, fontWeight: '600', color: ((this.state.countdown && parseInt(this.state.countdown) <= 10) ? config.colors.logo_pink : config.colors.font_color) }}>{this.state.countdown}</Text>
                            </View>
                            <StyledLinearProgress variant="determinate" value={parseInt(this.state.countDownPercentage)} fullWidth />
                        </View>


                        <View style={{width: '90%', justifyContent: 'center', marginTop: 20}}>


                        {/* Movie */}
                        {this.state.hasMovie ? (
                            <>
                                <StyledAutocomplete
                                    disablePortal
                                    id="movie-select"
                                    options={this.state.movies}
                                    fullWidth
                                    autoHighlight
                                    renderInput={(params) => <TextField {...params} inputProps={{...params.inputProps, autoCorrect: 'off', autoCapitalize: 'none', spellCheck: 'false'}} inputRef={this.movieRef} label={i18n.t('movie')}/>}
                                    onInputChange={(event, value) => {
                                        // clear the previous timeout
                                        clearTimeout(this.timeoutId);
                                        // start a new timeout
                                        this.timeoutId = setTimeout(() => {
                                            this.populateMovies(value);
                                        }, 500); // 500 milli seconds
                                    }}
                                    value={this.state.movie}
                                    onChange={(event, value) => {
                                        this.sendMovieAnswer(value.value, this.state.countdown, this.state.timeoutTimeInSeconds);
                                        this.setState({ movie: value.label, movieId: value.value, movieCheckmark: true});
                                        // focus the "Release" field
                                        { this.state.hasRelease ? this.releaseRef.current.focus() : null }
                                    }}
                                    isOptionEqualToValue={(option, value) => {
                                        return option.label === value;
                                    }}
                                    filterOptions={(options, state) => options} // show all options regardless of the input
                                /> 
                                <FormHelperText id="outlined-weight-helper-text" style={{color: 'green'}}>
                                    {this.state.movieCheckmark ? i18n.t('answer_saved') : ' '}
                                </FormHelperText>
                                <View style={{ margin: 2 }}></View>
                            </>
                        ) : null}

                        {/* Release */}
                        {this.state.hasRelease ? (
                            <>
                                <StyledAutocomplete
                                    disablePortal
                                    id="release-select"
                                    options={this.state.releases}
                                    fullWidth
                                    autoHighlight
                                    renderInput={(params) => <TextField {...params} inputProps={{...params.inputProps, autoCorrect: 'off', autoCapitalize: 'none', spellCheck: 'false'}} inputRef={this.releaseRef} label={i18n.t('title')}/>}
                                    onInputChange={(event, value) => {
                                        // clear the previous timeout
                                        clearTimeout(this.timeoutId);
                                        // start a new timeout
                                        this.timeoutId = setTimeout(() => {
                                            this.populateReleases(value);
                                        }, 500); // 500 milli seconds
                                    }}
                                    value={this.state.release}
                                    onChange={(event, value) => {
                                        this.sendReleaseAnswer(value.value, this.state.countdown, this.state.timeoutTimeInSeconds);
                                        this.setState({ release: value.label, releaseId: value.value, releaseCheckmark: true});
                                        // focus the "Artist Name" field
                                        { this.state.hasArtist ? this.artistRef.current.focus() : null }
                                    }}
                                    isOptionEqualToValue={(option, value) => {
                                        return option.label === value;
                                    }}
                                    filterOptions={(options, state) => options} // show all options regardless of the input
                                />
                                <FormHelperText id="outlined-weight-helper-text" style={{color: 'green'}}>
                                    {this.state.releaseCheckmark ? i18n.t('answer_saved') : ' '}
                                </FormHelperText>
                                <View style={{ margin: 2 }}></View>
                            </>
                        ) : null}

                        {/* Artist */}
                        {this.state.hasArtist ? (
                            <>
                                <StyledAutocomplete
                                    disablePortal
                                    id="artist-select"
                                    options={this.state.artists}
                                    fullWidth
                                    autoHighlight
                                    renderInput={(params) => <TextField {...params} inputProps={{...params.inputProps, autoCorrect: 'off', autoCapitalize: 'none', spellCheck: 'false'}} inputRef={this.artistRef} label={i18n.t('artist')} />}
                                    onInputChange={(event, value) => {
                                        // clear the previous timeout
                                        clearTimeout(this.timeoutId);
                                        // start a new timeout
                                        this.timeoutId = setTimeout(() => {
                                            this.populateArtists(value);
                                        }, 500); // 500 milli seconds
                                    }}
                                    value={this.state.artist}
                                    onChange={(event, value) => {
                                        this.sendArtistAnswer(value.value, this.state.countdown, this.state.timeoutTimeInSeconds);
                                        this.setState({ artist: value.label, artistId: value.value, artistCheckmark: true});
                                        // focus the "Language" field
                                        { this.state.hasLanguage ? this.languageRef.current.focus() : null }
                                    }}
                                    isOptionEqualToValue={(option, value) => {
                                        return option.label === value;
                                    }}
                                    filterOptions={(options, state) => options} // show all options regardless of the input
                                />
                                <FormHelperText id="outlined-weight-helper-text" style={{color: 'green'}}>
                                    {this.state.artistCheckmark ? i18n.t('answer_saved') : ' '}
                                </FormHelperText>
                                <View style={{ margin: 2 }}></View>
                            </>
                        ) : null}

                        {/* Language */}
                        {this.state.hasLanguage ? (
                            <>
                                <StyledAutocomplete
                                    disablePortal
                                    id="language-select"
                                    options={this.state.languages}
                                    fullWidth
                                    autoHighlight
                                    renderInput={(params) => <TextField {...params} inputProps={{...params.inputProps, autoCorrect: 'off', autoCapitalize: 'none', spellCheck: 'false'}} inputRef={this.languageRef} label={i18n.t('language')} />}
                                    onInputChange={(event, value) => {
                                        // clear the previous timeout
                                        clearTimeout(this.timeoutId);
                                        // start a new timeout
                                        this.timeoutId = setTimeout(() => {
                                            this.populateLanguages(value);
                                        }, 500); // 500 milli seconds
                                    }}
                                    value={this.state.language}
                                    onChange={(event, value) => {
                                        this.sendLanguageAnswer(value.value, this.state.countdown, this.state.timeoutTimeInSeconds);
                                        this.setState({ language: value.label, languageId: value.value, languageCheckmark: true});
                                    }}
                                    isOptionEqualToValue={(option, value) => {
                                        return option.label === value;
                                    }}
                                    filterOptions={(options, state) => options} // show all options regardless of the input
                                />
                                <FormHelperText id="outlined-weight-helper-text" style={{color: 'green'}}>
                                    {this.state.languageCheckmark ? i18n.t('answer_saved') : ' '}
                                </FormHelperText>
                                <View style={{ margin: 2 }}></View>
                            </>
                        ) : null}

                        </View>

                    </ScrollView>
                    </LinearGradient>
                ) : null}

                <View style={{ textAlign: 'center', alignItems: 'center', justifyContent: 'center', borderTopWidth: 1, borderTopColor: 'lightgray' }}>
                    <Text style={{ fontSize: 13, fontWeight: '600', color: config.colors.connection_font_color, marginTop: 5 }}>{i18n.t('connection_status')} : {i18n.t(this.state.mqttStatus)}</Text>
                    <Text style={{ fontSize: 13, color: config.colors.connection_font_color, marginBottom: 5 }}>
                        {this.state.songId ? (`${i18n.t('id')} : ${this.state.songId}`) : ''}
                    </Text>
                </View>
            </View>
        );
    }
}


